module.exports = __webpack_public_path__ + "img/D.a5d58829.jpg";